import { Size } from "../../../MyHelpers";
import { Settings } from "../../../Settings";
import { SlotGameInitData } from "../../../SlotGameInitData";
import { BigFreeGameBonusSlideDoubleSlide } from "./Slides/BigFreeGameBonusSlideDoubleSlide";
import { BigFreeGamePlusOneSlideDoubleSlide } from "./Slides/BigFreeGamePlusOneSlideDoubleSlide";
import { DiamondSpinSlideDoubleSlide } from "./Slides/DiamondSpinSlideDoubleSlide";
import { ExpandingWildBulkLeft } from "./Slides/ExpandingWildBulkLeft";
import { ExpandingWildBulkRightValue } from "./Slides/ExpandingWildBulkRightValue";
import { ExpandingWildReelLeft } from "./Slides/ExpandingWildReelLeft";
import { ExpandingWildReelValue } from "./Slides/ExpandingWildReelValue";
import { FreeGameBonusSlideDoubleSlide } from "./Slides/FreeGameBonusSlide";
import { FreeGamePlusOneSlideDoubleSlide } from "./Slides/FreeGamePlusOneSlideDoubleSlide";
import { GameTitleJackpotDisplaySlide } from "./Slides/GameTitleJackpotDisplaySlide";
import { GameTitleJackpotDisplaySlide1Screen } from "./Slides/GameTitleJackpotDisplaySlide1Screen";
import { GameTitleSlide } from "./Slides/GameTitleSlide";
import { GameTitleSlide1Screen } from "./Slides/GameTitleSlide1Screen";
import { HoldAndSpinLeft } from "./Slides/HoldAndSpinLeft";
import { HoldAndSpinRight } from "./Slides/HoldAndSpinRight";
import { SlideFactory2Params, Slide } from "./Slides/Slide";
import { TurboPlay } from "./Slides/TurboPlay";
import { WildSlideDoubleSlide } from "./Slides/WildSlideDoubleSlide";
import { SlideType } from "./SlideType";

export interface ISlideFactory2Side {
    CreatSlide2side(slideType: SlideType, initData: SlotGameInitData, p: SlideFactory2Params , viewSize : Size): Slide;
}

export interface ISlideStyleFactory2Side {
    CreateStyle(): Partial<CSSStyleDeclaration>;
}



export class SlideFactory2Side implements ISlideStyleFactory2Side, ISlideFactory2Side {



    public CreatSlide2side(slideType: SlideType, initData: SlotGameInitData, p: SlideFactory2Params , viewSize : Size): Slide {

		// TODO move to map?
		switch (slideType) {
			
			case SlideType.FreeGameBonus:
				return new FreeGameBonusSlideDoubleSlide(initData, p , viewSize);
			
			case SlideType.Wild:
				return new WildSlideDoubleSlide(initData, p , viewSize);
			
			case SlideType.ExpandingWildBulkLeft:
				return new ExpandingWildBulkLeft(initData, p , viewSize);
			
			case SlideType.ExpandingWildBulkRight:
				return new ExpandingWildBulkRightValue(initData, p , viewSize);
			
			case SlideType.ExpandingWildReelLeft:
				return new ExpandingWildReelLeft(initData, p , viewSize);
			
			case SlideType.ExpandingWildReelRight:
				return new ExpandingWildReelValue(initData, p , viewSize);

			// case SlideType.Jp:
			// 	return new JPSlideDoubleSlide(initData, p);
			
			// case SlideType.PickBonus:
			// 	return new PickBonusSlideDoubleSlide(initData, p);
			
			// case SlideType.ProgressivePickBonus:
			// 	return new ProgressivePickBonusDoubleSlide(initData, p);
			
			case SlideType.DiamondSpin:
				return new DiamondSpinSlideDoubleSlide(initData, p , viewSize);
			
			case SlideType.HoldAndSpinLeft:
				return new HoldAndSpinLeft(initData, p , viewSize);
			
			case SlideType.HoldAndSpinRight:
				return new HoldAndSpinRight(initData, p , viewSize);

			
			case SlideType.FreeGamePlusOne:
				return new FreeGamePlusOneSlideDoubleSlide(initData, p , viewSize);

			
			case SlideType.BigFreeGameBonus:
				return new BigFreeGameBonusSlideDoubleSlide(initData, p , viewSize);

			
			case SlideType.BigFreeGamePlusOne:
				return new BigFreeGamePlusOneSlideDoubleSlide(initData, p , viewSize);

			case SlideType.TurboPlay:
				return new TurboPlay(initData, p , viewSize);


			case SlideType.GameTitle:
				if (Settings.Screens >= 2) {
				return new GameTitleSlide(initData, p, viewSize);
				}
				else {
					return new GameTitleSlide1Screen(initData,p,viewSize)
				}
				
			case SlideType.GameTitleJackpotDisplay:
				if (Settings.Screens >= 2) {
					return new GameTitleJackpotDisplaySlide(initData, p, viewSize);
				}
				else {
					return new GameTitleJackpotDisplaySlide1Screen(initData, p, viewSize);
				}

			default:
				return null;
		}


    }

    public CreateStyle(): Partial<CSSStyleDeclaration> {
        let style: Partial<CSSStyleDeclaration> =
        {
        };

        return style;
    }
}
